import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BaseDisplayModel } from '@common/models/baseDisplayModel';
import { requiredValidator } from '@common/validators/required-validator';

export class ConfirmMovesDisplayModel extends BaseDisplayModel {
    manipulation: string;
    containerItemIds: any[];
    serviceRequestId: string;
    containerVisitId: number;
    containerNbr: string;

    constructor(data = null) {
        super();
        if (data) {
            Object.assign(this, data);
        }
    }

    generateGroup() {
        const form = new UntypedFormGroup({
            containerCount: new UntypedFormControl({ value: null, disabled: true }),
            serviceRequestId: new UntypedFormControl({ value: null, disabled: true }),
            manipulation: new UntypedFormControl({ value: null, disabled: true }),
            performedDate: new UntypedFormControl({ value: null, disabled: false }, requiredValidator()),
            name: new UntypedFormControl({ value: null, disabled: false }),
            containerNumber: new UntypedFormControl({ value: null, disabled: false }),
            seals: new UntypedFormArray([])
        });

        form.patchValue(this);
        return form;
    }
}
